<template>
  <div 
    v-if="controller && controller._id" 
    class="row mb-3"
  >
    <div class="col-12">
      <ControllerInfoCard
        :controller="controllerWithLastVersion"
        :title="controllerTypeText"
        :badge-mode="badgeMode"
        :variant="cardVariant"
      >
        <template #headerRightExtra>
          <div
            v-if="shouldShowClose"
            @click.stop="handleClose"
            class="controller-close-btn"
            role="button"
            aria-label="close"
          >
            <i class="fa-solid fa-x"></i>
          </div>
        </template>
      </ControllerInfoCard>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import ControllerInfoCard from './ControllerInfoCard.vue';
import { resolveControllerDisplayName } from '@/common/utils/controllerDisplayName';

const props = defineProps({
  controller: {
    type: Object,
    required: true,
    default: () => ({})
  },
  controllerType: {
    type: String,
    default: null
  },
  showClose: {
    type: Boolean,
    default: null // null이면 mode에 따라 자동 결정
  },
  mode: {
    // 'registration' | 'wizard' | 'wizard-complete' | 'setting'
    type: String,
    default: 'registration',
    validator: (value) => ['registration', 'wizard', 'wizard-complete', 'setting'].includes(value),
  },
});

const emit = defineEmits(['close']);
const store = useStore();

const controllerWithLastVersion = computed(() => {
  const base = props.controller || {};
  if (!base?.model) return base;
  const products = store.getters['home/getProducts'] || [];
  const product = products.find((p) => p.model === base.model);
  const lastVersion = product?.version;
  return lastVersion !== undefined ? { ...base, lastVersion } : base;
});

const controllerTypeText = computed(() => {
  if (props.controllerType) {
    return props.controllerType;
  }
  if (props.controller?.model || props.controller?.hwRevision || props.controller?._id) {
    const products = store.getters['home/getProducts'] || [];
    return resolveControllerDisplayName(props.controller, products);
  }
  return '컨트롤러';
});

const handleClose = () => {
  emit('close');
};

// mode에 따라 닫기 버튼 표시 여부 결정
const shouldShowClose = computed(() => {
  if (props.showClose !== null) {
    return props.showClose;
  }
  // mode에 따라 자동 결정
  return ['registration', 'setting'].includes(props.mode);
});

// mode에 따라 badge mode 결정
const badgeMode = computed(() => {
  if (props.mode === 'wizard-complete') {
    return 'none'; // 완료 단계에서는 배지 숨김
  }
  return 'auto';
});

// mode에 따라 variant 결정
const cardVariant = computed(() => {
  if (props.mode === 'wizard-complete') {
    return 'complete';
  }
  return 'default';
});
</script>

<style scoped>
.controller-close-btn {
  cursor: pointer;
  padding: 0.5rem;
  color: #6c757d;
  transition: all 0.2s ease;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
}

.controller-close-btn:hover {
  background-color: #f8f9fa;
  color: #212529;
}
</style>
